import gridContainer, { featureGridStyles } from './grid-container';
import titleSection from './title-section';

const featureGrid = {
  titleSection,
  gridContainer
};

export type FeatureGridVariantsType = 'default' | 'masonry' | 'offset' | 'cards';

const variants = Object.keys(featureGridStyles) as FeatureGridVariantsType[];

export const featureGridVariants = {
  titleSection: variants,
  gridContainer: variants
};

export default featureGrid;
